import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import {Switch} from '../Switch';

storiesOf('base', module).add('Switch', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Switch</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>Switch</Code> component is used to render a switch.
        </Text>
        <Spacer size={16} />
        <Switch />
        <Spacer size={16} />
        <Text>
          The backgroud color of the switch is managed by the component itself
          and is determined by the competency using <Code>getTheme</Code> by{' '}
          <Code>ThemeProvider</Code>.
        </Text>
        <Spacer size={16} />
        <Text>Example of use:</Text>
        <Spacer size={16} />
        <Code>{'<Switch '}</Code>
        <Code>{'  onToggleSwitch={onToggleSwitch} '}</Code>
        <Code>{'  isEnabled={isEnabled}'}</Code>
        <Code>{'/>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
